import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { isFeatureEnabled } from '../../config/featureFlags';
import InsurancePoliciesPage from './pages/InsurancePoliciesPage';

/**
 * "Sigorta" (Tamamlıyo) — sigorta artık AYRI satılmıyor: uçuş rezervasyonunun ödeme
 * adımında sunuluyor (`src/modules/air/components/AirInsurancePanel.tsx` +
 * `flowConfig.ts` `runPayment` zinciri, legacy `FlightController.MakeReservedPayment`).
 * Bu modül yalnızca "Poliçelerim" yönetim ekranını (teklifId ile poliçe sorgu, PDF indir,
 * iptal talebi) barındırır. `HasInsurance` flag'iyle gizlenebilir.
 */
const isVisible = () => isFeatureEnabled('HasInsurance');

export const insuranceModule: ModuleDefinition = {
  routes: [{ path: 'insurance/policies', element: <InsurancePoliciesPage /> }],
  menuItems: [
    {
      label: 'Poliçelerim',
      path: 'insurance/policies',
      icon: <PolicyOutlinedIcon />,
      group: 'Sigorta',
      groupIcon: <ShieldOutlinedIcon />,
      isVisible,
    },
  ],
};
